import i18n from '@/locales'
export default {
  index: 100,
  meta: {
    label: i18n.t('bill.menu'),
    icon: 'menu-meter',
    catalog: 'other',
  },
  menus: [
    {
      meta: {
        label: i18n.t('bill.menu.accountOverview'),
      },
      submenus: [
        {
          path: '/llm/bill/account-overview',
          meta: {
            label: i18n.t('bill.menu.accountOverview'),
            permission: 'bill_bill_list',
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('bill.menu.fund'),
      },
      submenus: [
        {
          path: '/llm/bill/funds',
          meta: {
            label: i18n.t('bill.menu.fund.detail'),
            permission: 'bill_fund_list',
          },
        },
        {
          path: '/llm/bill/recharge',
          meta: {
            label: i18n.t('bill.menu.fund.recharge'),
            permission: 'bill_balance_update',
          },
        },
        {
          path: '/llm/bill/history',
          meta: {
            label: i18n.t('bill.menu.fund.history'),
            permission: 'bill_fund_list',
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('bill.menu.order'),
      },
      submenus: [
        {
          path: '/llm/bill/bills',
          meta: {
            label: i18n.t('bill.menu.order.my'),
            permission: 'bill_bill_list',
          },
        },
        // {
        //   path: '/llm/bill/subscriptions',
        //   meta: {
        //     label: '我的订阅',
        //   },
        // },
      ],
    },
    {
      meta: {
        label: i18n.t('bill.menu.bill'),
      },
      submenus: [
        {
          path: '/llm/bill/overview',
          meta: {
            label: i18n.t('bill.menu.bill.overview'),
            permission: 'bill_bill_list',
          },
        },
        {
          path: '/llm/bill/cycle',
          meta: {
            label: i18n.t('bill.menu.bill.cycle'),
            permission: 'bill_bill_list',
          },
        },
        {
          path: '/llm/bill/cost-report',
          meta: {
            label: i18n.t('bill.menu.bill.cost'),
            permission: 'bill_bill_list',
          },
        },
        {
          path: '/llm/bill/usage',
          meta: {
            label: i18n.t('bill.menu.bill.usage'),
            permission: 'bill_bill_list',
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('bill.menu.invoices'),
      },
      submenus: [
        {
          path: '/llm/bill/invoice',
          meta: {
            label: i18n.t('bill.menu.invoices.invoice'),
            permission: 'bill_bill_list',
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('bill.menu.userRights'),
      },
      submenus: [
        {
          path: '/llm/bill/coupons',
          meta: {
            label: i18n.t('bill.menu.userRights.coupons'),
            permission: 'bill_bill_list',
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('bill.menu.admin'),
      },
      submenus: [
        {
          path: '/llm/bill/admin-recharge',
          meta: {
            label: i18n.t('bill.menu.admin.recharge'),
            permission: 'bill_admin_list',
          },
        },
        {
          path: '/llm/bill/admin-bills',
          meta: {
            label: i18n.t('bill.menu.admin.bills'),
            permission: 'bill_admin_list',
          },
        },
        // {
        //   path: '/llm/bill/plans',
        //   meta: {
        //     label: i18n.t('bill.menu.admin.plans'),
        //     permission: 'bill_admin_list',
        //   },
        // },
        {
          path: '/llm/bill/admin-products',
          meta: {
            label: i18n.t('bill.menu.admin.products'),
            permission: 'bill_admin_list',
          },
        },
        {
          path: '/llm/bill/admin-promotions',
          meta: {
            label: i18n.t('bill.menu.admin.promotions'),
            permission: 'bill_admin_list',
          },
        },
        {
          path: '/llm/bill/admin-coupons',
          meta: {
            label: i18n.t('bill.menu.admin.coupons'),
            permission: 'bill_admin_list',
          },
        },
        {
          path: '/llm/bill/admin-invoice',
          meta: {
            label: i18n.t('bill.menu.admin.invoice'),
            permission: 'bill_admin_list',
          },
        },
      ],
    },
  ],
}
